import { jsx as _jsx } from "react/jsx-runtime";
import MatChip from '@mui/material/Chip';
import makeStyles from '@mui/styles/makeStyles';
import { COLOR } from '../theme/colors';
const useStyles = makeStyles({
    selected: {
        backgroundColor: '#F1F7FF',
        borderColor: '#BCD5FF',
    },
    root: {
        borderRadius: `4px !important`
    },
    eDefault: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillEmphasisColors.default.bgColor} !important`,
        color: `${COLOR.pillEmphasisColors.default.color} !important`
    },
    sDefault: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillSubtleColors.default.bgColor} !important`,
        color: `${COLOR.pillSubtleColors.default.color} !important`,
        border: `1px solid ${COLOR.pillSubtleColors.default.outlineColor} !important`
    },
    ePrimary: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillEmphasisColors.primary.bgColor} !important`,
        color: `${COLOR.pillEmphasisColors.primary.color} !important`
    },
    sPrimary: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillSubtleColors.primary.bgColor} !important`,
        color: `${COLOR.pillSubtleColors.primary.color} !important`,
        border: `1px solid ${COLOR.pillSubtleColors.primary.outlineColor} !important`
    },
    eMagenta: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillEmphasisColors.magenta.bgColor} !important`,
        color: `${COLOR.pillEmphasisColors.magenta.color} !important`
    },
    sMagenta: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillSubtleColors.magenta.bgColor} !important`,
        color: `${COLOR.pillSubtleColors.magenta.color} !important`,
        border: `1px solid ${COLOR.pillSubtleColors.magenta.outlineColor} !important`
    },
    eAttention: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillEmphasisColors.attention.bgColor} !important`,
        color: `${COLOR.pillEmphasisColors.attention.color} !important`
    },
    sAttention: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillSubtleColors.attention.bgColor} !important`,
        color: `${COLOR.pillSubtleColors.attention.color} !important`,
        border: `1px solid ${COLOR.pillSubtleColors.attention.outlineColor} !important`
    },
    eImportant: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillEmphasisColors.important.bgColor} !important`,
        color: `${COLOR.pillEmphasisColors.important.color} !important`
    },
    sImportant: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillSubtleColors.important.bgColor} !important`,
        color: `${COLOR.pillSubtleColors.important.color} !important`,
        border: `1px solid ${COLOR.pillSubtleColors.important.outlineColor} !important`
    },
    eSuccess: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillEmphasisColors.success.bgColor} !important`,
        color: `${COLOR.pillEmphasisColors.success.color} !important`
    },
    sSuccess: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillSubtleColors.success.bgColor} !important`,
        color: `${COLOR.pillSubtleColors.success.color} !important`,
        border: `1px solid ${COLOR.pillSubtleColors.success.outlineColor} !important`
    },
    eNeutral: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillEmphasisColors.neutral.bgColor} !important`,
        color: `${COLOR.pillEmphasisColors.neutral.color} !important`
    },
    sNeutral: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillSubtleColors.neutral.bgColor} !important`,
        color: `${COLOR.pillSubtleColors.neutral.color} !important`,
        border: `1px solid ${COLOR.pillSubtleColors.neutral.outlineColor} !important`
    },
    eDisabled: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillSubtleColors.disabled.bgColor} !important`,
        color: `${COLOR.pillSubtleColors.disabled.color} !important`,
        border: `1px solid ${COLOR.pillSubtleColors.disabled.outlineColor} !important`
    },
    sDisabled: {
        borderRadius: `4px !important`,
        backgroundColor: `${COLOR.pillSubtleColors.disabled.bgColor} !important`,
        color: `${COLOR.pillSubtleColors.disabled.color} !important`,
        border: `1px solid ${COLOR.pillSubtleColors.disabled.outlineColor} !important`
    }
});
export const Pill = (props) => {
    const classes = useStyles(props);
    let rootUpdate = classes.root;
    const variant = props.variant;
    let prefix = 'e';
    switch (variant) {
        case 'outlined':
            prefix = 's';
            break;
        case 'filled':
            prefix = 'e';
            break;
        default:
            prefix = 'e';
            break;
    }
    if (props.type) {
        const type = prefix + props.type;
        switch (type) {
            case 'edefault':
                rootUpdate = classes.eDefault;
                break;
            case 'sdefault':
                rootUpdate = classes.sDefault;
                break;
            case 'eprimary':
                rootUpdate = classes.ePrimary;
                break;
            case 'sprimary':
                rootUpdate = classes.sPrimary;
                break;
            case 'emagenta':
                rootUpdate = classes.eMagenta;
                break;
            case 'smagenta':
                rootUpdate = classes.sMagenta;
                break;
            case 'eattention':
                rootUpdate = classes.eAttention;
                break;
            case 'sattention':
                rootUpdate = classes.sAttention;
                break;
            case 'eimportant':
                rootUpdate = classes.eImportant;
                break;
            case 'simportant':
                rootUpdate = classes.sImportant;
                break;
            case 'esuccess':
                rootUpdate = classes.eSuccess;
                break;
            case 'ssuccess':
                rootUpdate = classes.sSuccess;
                break;
            case 'eneutral':
                rootUpdate = classes.eNeutral;
                break;
            case 'sneutral':
                rootUpdate = classes.sNeutral;
                break;
            case 'edisabled':
                rootUpdate = classes.eDisabled;
                break;
            case 'sdisabled':
                rootUpdate = classes.sDisabled;
                break;
            default:
                rootUpdate = classes.eDefault;
                break;
        }
    }
    else {
        rootUpdate = classes.eDefault;
    }
    const padding = props.size === 'small' ? 8 : 12;
    return (_jsx(MatChip, Object.assign({}, props, { onDelete: undefined, classes: {
            root: rootUpdate,
        }, sx: {
            "& .MuiChip-label": {
                paddingLeft: `${padding}px !important`,
                paddingRight: `${padding}px !important`,
                fontSize: '14px',
                fontWeight: 500,
                lineHeight: '20px'
            }
        } })));
};
